import Vue from 'vue'
import Vuex from 'vuex'
import router from './../router'
import decode from 'jwt-decode'
import account from "./account/account"
import cliente from "./cliente/cliente"
import configuracion from "./configuracion/configuracion"


Vue.use(Vuex)

export default new Vuex.Store({
  state: {    
    ocupado: false,
    mensajeOcupado: '',
    mensaje: null,
    notificacion:{
      visible:false,
      mensaje:'',
      color:'info'
    }
  },
  mutations: {    
    mostrarOcupado (state, mensaje) {
      state.mensajeOcupado = mensaje
      state.ocupado = true
    },
    ocultarOcupado (state) {
      state.mensajeOcupado = ''
      state.ocupado = false
    },
    setMensaje (state, mensaje) {
      state.mensaje = mensaje;
    },
    mostrarNotificiacionInfo(state,mensaje){
      state.notificacion.mensaje = mensaje
      state.notificacion.color = 'info'
      state.notificacion.visible=true
    },
    mostrarNotificiacionExito(state,mensaje){
      state.notificacion.mensaje = mensaje
      state.notificacion.color = 'success'
      state.notificacion.visible=true
    }
  },
  actions: {
    mostrarMensaje ({commit}, mensaje) {
      commit('setMensaje', mensaje)
      router.push({ name: 'mensaje' })
    }
  },
  getters: {    
    ocupado (state) {
      return state.ocupado
    },
    mensajeOcupado (state) {
      return state.mensajeOcupado
    },
    mensaje (state) {
      return state.mensaje
    },
    idCliente (state) {

      if(state.account.token)
      {
        let user = decode(state.account.token)
        if(user.idCliente){
          return user.idCliente
        }
      }

      return null
    }
  },
  modules: {
    configuracion,
    account,
    cliente   
  }
})
